import './utilities/log';

import './components/plyr';
import * as bootstrap from 'bootstrap';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import Splide from "@splidejs/splide";

import './components/header-scroll-up/header-scroll-up';
import './components/slider';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);


///
// Progress bar (ScrollTrigger)
///

gsap.to(".page-progress-bar", {
  value: 100,
  ease: 'none',
  scrollTrigger: { scrub: 0.1 }
});


// Detect if a link's href goes to the current page
function getSamePageAnchor (link) {
  if (
    link.protocol !== window.location.protocol ||
    link.host !== window.location.host ||
    link.pathname !== window.location.pathname ||
    link.search !== window.location.search
  ) {
    return false;
  }

  return link.hash;
}

// Scroll to a given hash, preventing the event given if there is one
function scrollToHash(hash, e) {
  const elem = hash ? document.querySelector(hash) : false;
  if ( elem ) {
    if ( e ) e.preventDefault();
    gsap.to( window, { scrollTo: elem } );
    // smoother.scrollTo(elem, true)
  }
}

// If a link's href is within the current page, scroll to it instead
document.querySelectorAll( 'a[href]' ).forEach( a => {
  a.addEventListener( 'click', e => {
    scrollToHash( getSamePageAnchor( a ), e );
  });
});

// Scroll to the element in the URL's hash on load
scrollToHash(window.location.hash);

///
// Splide slider for timeline
///

document.addEventListener( 'DOMContentLoaded', function () {

  let splide;
  let previousButton, nextButton;

  previousButton = document.querySelector('.splide-timeline .previous-button');
  nextButton = document.querySelector('.splide-timeline .next-button');

  const main = new Splide('#main-carousel', {
    autoplay: false,
    interval: 7000,
    pauseOnHover: false,
    arrows: false,
    perPage: 1,
    perMove: 1,
    gap: '1.5em',
    type: 'slide',
    pagination: false,
    keyboard: false,
    slideFocus: false,
    mediaQuery: 'min',
    breakpoints: {
      576: {
        perPage: 1
      },
      768: {
        perPage: 2
      },
      992: {
        perPage: 3
      },
      1200: {
        perPage: 4
      },
      1400: {
        perPage: 4
      }
    },
  });

  main.on('move', function() {
    var slides = document.querySelectorAll('.splide .splide__slide');

    slides.forEach(function(slide) {
      slide.classList.add('is-visible');
    });
  });

  // Go to the previous slide when the Previous button is activated
  previousButton.addEventListener('click', function(e) {
    main.go('<');
  });

  // Go to the next slide when the Next button is activated
  nextButton.addEventListener('click', function(e) {
    main.go('>');
  });

  const thumbnails = new Splide( '#thumbnail-carousel', {
    rewind: true,
    pagination: false,
    arrows: false,
    isNavigation: true,
    autoWidth: true,
    breakpoints: {
      576: {
        center: true
      },
      768: {
        center: true
      },
      992: {
        center: true
      },
      1200: {
        center: false
      },
      1400: {
        center: false
      }
    },
  } );

  main.sync( thumbnails );
  main.mount();
  thumbnails.mount();
} );

///
// Close navigation after click
///

const navLinks = document.querySelectorAll('.dropdown-item')
const menuToggle = document.getElementById('navbarSupportedContent')
const bsCollapse = new bootstrap.Collapse(menuToggle, {toggle:false})
navLinks.forEach((l) => {
  l.addEventListener('click', () => { bsCollapse.toggle() })
})


///
// Import styles
///

import '../styles/index.scss';
